import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";


import SpeechToTextLongTime from "./VoiceToVoice/SpeechToTextLongTime.jsx";
import TextToText from "./TextToText/TextToText.jsx";
import TextVoiceAssistantAbout from "./TextVoiceAssistantAbout.jsx";
import OllamaMcpServerGet from "./OllamaMcpServerGet.jsx";

import { useStore } from '../../hook-store/store.js';
import { getTextVoiceAssistantConfig } from "../../utils/ollama/text-voice-assistant.js";

import { 
  ollamaNodeJsUrl,
} from "../../App.js";

import { marks } from "../../utils/marks.jsx";
import './TextVoiceAssistant.css';


function TextVoiceAssistant() {

    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    // console.log('store-App.tsx', store);
    // const { mlIsBusy } = store.uiStore;
    // const { 
    //     mlSpeechCurrentAudioData,
    //     mlSpeechText,
    // } = store.mlSpeechStore;
    
    // const [showPageAbout, setShowPageAbout] = useState(false);
    const [inputMode, setInputMode] = useState('text');
    const [showAbout, setShowAbout] = useState(false);
    const [textVoiceAssistantConfig, setTextVoiceAssistantConfig] = useState();

    useEffect(() => {
        window.scrollTo(0, 0);
    },[]);

    useEffect(() => {
        getAssistantConfigHandler();
    },[]);
    
    const setInputModeHandler = (mode) => {
        setInputMode(mode);
    };

    const getAssistantConfigHandler = async() => {
        try {
            const resData = await getTextVoiceAssistantConfig(
                ollamaNodeJsUrl,
                localStorage.getItem('token'),
            );

            if (resData && resData.data && resData.data.textVoiceAssistantConfig) {
                setTextVoiceAssistantConfig(resData.data.textVoiceAssistantConfig);
            }

        } catch(err) {
            console.log(err);
            throw err;
        }
    }


    let modeSelectStyle = {
        fontWeight: "bold",
    };
    
    let textVoiceAssistantBody = (
        <div>
            <div className="textVoiceAssistantRow">
                <div className="textVoiceAssistantTitle">
                    <span>
                        Text Voice Assistant
                    </span>
                    <span 
                        style={{color:"gray"}}
                        onClick={() => {
                            setShowAbout(!showAbout);
                        }}
                    >
                        {' '}{marks.questionCircleOMark}
                    </span>
                </div>

                {showAbout && (
                    <div className="textVoiceAssistantRow">
                        <TextVoiceAssistantAbout />
                    </div>
                )}
            </div>
            

            <div className="textVoiceAssistantRow">
                <span className="textVoiceAssistantModeButton"
                    style={inputMode === 'text' ? modeSelectStyle : null}
                    onClick={() => {
                        setInputModeHandler('text');
                    }}
                >
                    <span style={{color: "gray"}}>
                        {marks.editMark} 
                    </span>
                    <span>
                        {' '}{t("textVoiceAssistant01", "Text input")}
                    </span>
                </span>
                <span className="textVoiceAssistantModeButton"
                    style={inputMode === 'voice' ? modeSelectStyle : null}
                    onClick={() => {
                        setInputModeHandler('voice');
                    }}
                >
                    <span style={{color: "gray"}}>
                        {marks.microphoneMark} 
                    </span>
                    <span>
                        {' '}{t("textVoiceAssistant02", "Voice input")}
                    </span>
                </span>
            </div>
            
            {inputMode === 'voice' && (
                <SpeechToTextLongTime />
            )}
            {inputMode === 'text' && (
                <TextToText 
                    textVoiceAssistantConfig={textVoiceAssistantConfig}
                />
            )}

        </div>
    );


    let bannerElement;

    if (window.innerWidth <= 450) {
      bannerElement = (
        <iframe id="kura-text-audio-tools.spaceeight.net-1725583665876"
            style={{width:"310px", height:"70px", border:"none"}}  
            src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583665876"
        />
      );
    }
  
    if (window.innerWidth > 450 && window.innerWidth <= 768) {
      bannerElement = (
        <iframe id="kura-text-audio-tools.spaceeight.net-1725583679744"
        style={{width:"460px", height:"95px", border:"none"}}  
        src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583679744"
        />
      )
    }
  
    if (window.innerWidth > 768) {
      bannerElement = (
        <iframe id="kura-text-audio-tools.spaceeight.net-1725583699146"
            style={{width:"610px", height:"135px", border:"none"}}  
            src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583699146"
        />
      );
    }


    return (
        <Fragment>
            <div 
                style={{
                    display: 'flex',
                    justifyContent: "center",
                    paddingTop: "1rem",
                    paddingBottom: "1rem"
                }}
            >
                {bannerElement}
            </div>
            
            <div>{textVoiceAssistantBody}</div>
            {/* <SpeechToText /> */}
            {/* <TranscribeAudioGetSttServer /> */}

            <OllamaMcpServerGet />
        </Fragment>
    );
}

export default TextVoiceAssistant;
